import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import { ActionsProps } from '@lib/components/ReactHookForm/types';

export interface FormProps extends ActionsProps {
  onCancel: () => void;
}

export default function LegendModalFormActions(props: FormProps) {
  const { loading, onCancel, onSubmitForm } = props;
  const { t } = useTranslation();
  const onSubmitHandler = () => {
    onSubmitForm();
  };
  const actions = [
    <Button
      buttonText={t('cancel')}
      buttonType={ButtonTypes.secondaryOutlined}
      disabled={loading}
      fullWidth
      leftIcon="close"
      onClick={onCancel}
    />,
    <Button
      buttonText={t('apply')}
      buttonType={ButtonTypes.primaryFilled}
      disabled={loading}
      fullWidth
      leftIcon="check"
      type="submit"
      onClick={onSubmitHandler}
    />,
  ];
  return <ActionsRow actions={actions} />;
}
